import { createSlice } from '@reduxjs/toolkit'
import { Notification, NotificationState } from './types'

export const initialNotificationsState: NotificationState = {
  entities: {},
  ids: [],
  count: 0,
  selected: null,
  notificationTypesConfig: {
    general: {
      name: 'General',
      features: {}
    },
    error: {
      name: 'Error',
      features: {}
    },
    warning: {
      name: 'Warning',
      features: {}
    },
    success: {
      name: 'Success',
      features: {}
    },
    download: {
      name: 'Download',
      features: {}
    },
    info: {
      name: 'Info',
      features: {}
    }
  }
}

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: initialNotificationsState,
  reducers: {
    addNotification: (
      state,
      action: { payload: Omit<Notification, 'id' | 'timestamp' | 'read'> }
    ) => {
      const timestamp = new Date().getTime()
      const id = `${action.payload.type}-${timestamp}`

      state.entities = {
        ...state.entities,
        [id]: {
          ...action.payload,
          timestamp,
          id,
          read: false
        }
      }

      state.ids.push(id)
      state.count += 1
    },
    readNotification: (state, action: { payload: string }) => {
      state.entities[action.payload].read = true
    }
  }
})

export const reducer = notificationsSlice.reducer

export const { addNotification, readNotification } = notificationsSlice.actions
